import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import api from '../lib/api';

const ago = (iso) => {
  const s = (Date.now() - new Date(String(iso).endsWith('Z') ? iso : `${iso}Z`).getTime()) / 1000;
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
};

export const linkFor = (d = {}) => {
  if (d.type === 'live') return d.room ? `/members/live/${d.id}` : '/live';
  if (d.type === 'program') return d.slug ? `/programs/${d.slug}` : '/dashboard/bookings';
  if (d.type === 'post') return '/community';
  if (d.type === 'link') return d.url;
  return null;
};

export const NotificationBell = () => {
  const nav = useNavigate();
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const load = () => api.get('/notifications').then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  const onOpen = (v) => { setOpen(v); if (v && data.unread) api.post('/notifications/read', {}).then(() => setData((p) => ({ ...p, unread: 0 }))).catch(() => {}); };
  const go = (n) => {
    const to = linkFor(n.data);
    setOpen(false);
    if (!to) return;
    if (/^https?:\/\//.test(to)) window.open(to, '_blank', 'noopener'); else nav(to);
  };
  return (
    <Popover open={open} onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button className="relative w-10 h-10 flex items-center justify-center rounded-full hover:bg-rose-soft/40 transition-colors" aria-label="Notifications" data-testid="header-notifications">
          <Bell className="w-4.5 h-4.5 text-burgundy" />
          {data.unread > 0 && <span className="absolute top-0.5 right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] flex items-center justify-center" data-testid="notifications-unread">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[340px] max-w-[92vw] p-0 bg-cream border-rose/40" data-testid="notifications-panel">
        <div className="px-4 py-3 border-b border-rose/30 font-serif-display text-lg text-burgundy">Notifications</div>
        <div className="max-h-[420px] overflow-y-auto divide-y divide-rose/20">
          {data.items.length === 0 ? <p className="p-6 text-center text-sm text-mahogany/60">You're all caught up.</p>
            : data.items.map((n) => (
              <button key={n.id} onClick={() => go(n)} className={`w-full text-left px-4 py-3 hover:bg-white/60 transition-colors ${n.read ? '' : 'bg-rose-soft/30'}`} data-testid={`notification-${n.id}`}>
                <div className="flex justify-between gap-2"><span className="text-sm font-medium text-burgundy">{n.title}</span><span className="text-[11px] text-mahogany/50 shrink-0">{ago(n.created_at)}</span></div>
                <p className="text-xs text-mahogany/75 mt-0.5 line-clamp-2">{n.body}</p>
              </button>
            ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default NotificationBell;
